import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { parseEnvBoolean, parseEnvNumber, normalizeEnvName } from '@/utils/env';

/**
 * Initialize Datadog SDKs for browser
 *
 */
export function initDatadogForBrowser() {
  if (
    !process.env.NEXT_PUBLIC_DD_APP_ID ||
    !process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN ||
    typeof window === 'undefined' ||
    datadogRum.getInitConfiguration() !== undefined ||
    datadogLogs.getInitConfiguration() !== undefined
  ) {
    return;
  }

  /*
   * References:
   * - parameters https://docs.datadoghq.com/real_user_monitoring/browser/#configuration
   */
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DD_APP_ID,
    clientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'mercari-work-jp-worker-web-browser',
    env: normalizeEnvName(process.env.NEXT_PUBLIC_APP_ENV),
    version: process.env.NEXT_PUBLIC_VERSION,
    sessionSampleRate: parseEnvNumber(process.env.NEXT_PUBLIC_DD_RUM_SESSION_SAMPLE_RATE),

    sessionReplaySampleRate: parseEnvNumber(process.env.NEXT_PUBLIC_DD_SESSION_REPLAY_SAMPLE_RATE),
    trackUserInteractions: parseEnvBoolean(process.env.NEXT_PUBLIC_DD_TRACK_USER_INTERACTIONS),

    trackResources: true,
    trackLongTasks: true,

    allowedTracingUrls: [`${window.location.origin}${process.env.NEXT_PUBLIC_API_URL}`],
    traceSampleRate: parseEnvNumber(process.env.NEXT_PUBLIC_DD_TRACE_SAMPLE_RATE),
  });
  /*
   * References:
   * - parameters https://docs.datadoghq.com/logs/log_collection/javascript/#initialization-parameters
   */
  datadogLogs.init({
    clientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'mercari-work-jp-worker-web-browser',
    env: normalizeEnvName(process.env.NEXT_PUBLIC_APP_ENV),
    version: process.env.NEXT_PUBLIC_VERSION,
    sessionSampleRate: parseEnvNumber(process.env.NEXT_PUBLIC_DD_LOG_SESSION_SAMPLE_RATE),
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error', 'warn'],
    telemetrySampleRate: 0,
  });
}
